import styled from "styled-components";

export const UserAvatarImg = styled.img`
  align-items: center;
  background-color: white;
  border-radius: 50px;
  width: var(--navbar-avatar-size);
  height: var(--navbar-avatar-size);
  object-fit: cover;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(18, 42, 66, 0.03);
`

export const NoUserAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-primary);
  border-radius: 50%;
  width: var(--navbar-avatar-size);
  height: var(--navbar-avatar-size);
`

export const DefaultAvatar = styled.i`
  color: white;
  font-size: 25px;
`
